// ABOUTME: A single top-level AppBar nav entry, rendered as a real anchor wrapping a DS Button.
// ABOUTME: Highlights itself when the current route starts with its destination.

import { Button } from '@ds/coolshop';
import { toTitleCase } from '@src/utils';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { Link, useLocation, useNavigate } from 'react-router-dom';

type LinkToProps = {
    dest: string;
    disabled?: boolean;
    icon: ReactNode;
    /** Filled twin of `icon`, shown while the route is active. */
    activeIcon?: ReactNode;
    label?: string;
};

export const LinkTo = ({ dest, icon, activeIcon, disabled, label }: LinkToProps) => {
    const intl = useIntl();
    const { pathname } = useLocation();

    const navigate = useNavigate();

    const destination = `/${dest}`;

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        // Allow middle-click, right-click, and Ctrl/Cmd+click to work naturally
        // These will open in new tab/window, so we don't need to block them
        if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || disabled) {
            return;
        }

        e.preventDefault();
        navigate(destination);
    };

    const active = pathname.startsWith(destination);

    return (
        <Link
            to={destination}
            onClick={handleClick}
            style={{
                textDecoration: 'none',
                pointerEvents: disabled ? 'none' : 'auto',
                opacity: disabled ? 0.5 : 1,
            }}
        >
            <Button
                disabled={disabled}
                startIcon={active && activeIcon ? activeIcon : icon}
                variant="text"
                color={active ? 'secondary' : 'primary'}
                // invertedColor={!active}
            >
                {label ??
                    intl.formatMessage({
                        id: dest,
                        defaultMessage: toTitleCase(dest),
                    })}
            </Button>
        </Link>
    );
};
